module.exports = __webpack_public_path__ + "img/hr-stack-inserter-hand-base.ac420667.png";